import { Link } from 'react-router-dom';

import '../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faPenAlt, faPhone } from '@fortawesome/free-solid-svg-icons';

function PhoneCard(prop) {
 const { phones: { idpho, phonenumber, contactid }, changeVisibityMessages, setPhoneModify, setIidModPhone, del, handleClickToCall } = prop;

  return (
    <div name= {phonenumber } id={ phonenumber } className="card field column is-offset-two-quarter is-half has-text-centered mx-1">
      <header className="card-header has-text-centered">
        <p className="card-header-title has-text-centered">
          { phonenumber &&  Number(phonenumber.split('')[0]) === 8 ? '0' + phonenumber : phonenumber }
        </p>
        <button className="card-header-icon" aria-label="more options" onClick={ () => handleClickToCall(phonenumber) }>
          <span className="icon">
            <FontAwesomeIcon icon={ faPhone } fixedWidth />
          </span>
        </button>
      </header>
      <footer className="card-footer">
        <Link to="#" className="card-footer-item" onClick={ () => {
          setPhoneModify({ idpho, phonenumber })
          setIidModPhone(idpho)
          changeVisibityMessages(true, 'buttons-edit-contact');
          changeVisibityMessages(true, 'list-phones');
          changeVisibityMessages(false, 'input-edit-phone');
        } }>Edit</Link>
        <p to="#" className="card-footer-item mx-2 is-2"></p>
        <Link to="#" name={ `delete-phone-link-${idpho}` } className="card-footer-item is-active" onClick={ () => {
          changeVisibityMessages(true, `delete-phone-link-${idpho}`);
          changeVisibityMessages(false, `delete-phone-confirm-${idpho}`);
        } }>Delete</Link>
        <Link to="#" name={ `delete-phone-confirm-${idpho}` } className="card-footer-item has-background-danger has-text-black-bis is-hidden" onClick={ () => { del({ value: idpho, phone: phonenumber }) } }>Confirmar</Link>
      </footer>
    </div>
  )
}

export default PhoneCard;
